export { SearchResultsSectionDS } from './search-results-section-ds'
